import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import AOS from "aos";
import "aos/dist/aos.css";
import i18n from "./i18n";
import store from "./store/store";

import Vue3Toastify, { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";

import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

import BootstrapVueNext from "bootstrap-vue-next";
import vClickOutside from "click-outside-vue3";
import VueApexCharts from "vue3-apexcharts";
import { vMaska } from "maska";

import VueFeather from "vue-feather";

import "@/assets/scss/config/material/app.scss";
import "@/assets/scss/mermaid.min.css";
import "bootstrap/dist/js/bootstrap.bundle";

import FloatingVue from 'floating-vue'
import 'floating-vue/dist/style.css'

AOS.init({
  easing: "ease-out-back",
  duration: 1000,
});

createApp(App)
  .use(store)
  .use(router)
  .use(VueApexCharts)
  .use(BootstrapVueNext)
  .component(VueFeather.type, VueFeather)
  .directive("maska", vMaska)
  .use(i18n)
  .use(VueSweetalert2)
  .use(vClickOutside)
  .use(FloatingVue,{
    themes: {
      tooltip: {
        placement: 'top',     
        triggers: ['hover'], 
        delay: {
          show: 500,
          hide: 0,
        },      
      },
    },
  })
  .use(Vue3Toastify, {
    autoClose: 2000,
    position: toast.POSITION.TOP_CENTER,
    toastClassName: "fs-14",
  })
  .mount("#app");
